export default "__VITE_ASSET__u4QS3bsf__"